export default "__VITE_ASSET__07c974ae__"